import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, addDoc, updateDoc, doc, serverTimestamp, Timestamp } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const hizmetler = ['Cihaz Tamiri', 'Kontrol', 'Muayene', 'Maske Denemesi', 'Uyku Testi', 'Diğer'];
const durumlar = ['Yeni', 'Aranacak', 'Geri Arandı', 'İptal Oldu', 'Müşteriye Dönüştü'];

const PreInterviewFormModal = ({ isOpen, onClose, interviewToEdit }) => {
    const { currentUser } = useAuth();
    const [formData, setFormData] = useState({
        adSoyad: '', telefon: '', ilgilenilenHizmet: '', cihazHizmet: '', notlar: '', durum: 'Yeni'
    });
    const [geriAramaTarihi, setGeriAramaTarihi] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const isEditing = Boolean(interviewToEdit);

    useEffect(() => {
        if (isOpen) {
            if (isEditing && interviewToEdit) {
                setFormData({
                    adSoyad: interviewToEdit.adSoyad || '',
                    telefon: interviewToEdit.telefon || '',
                    ilgilenilenHizmet: interviewToEdit.ilgilenilenHizmet || '',
                    cihazHizmet: interviewToEdit.cihazHizmet || '',
                    notlar: interviewToEdit.notlar || '',
                    durum: interviewToEdit.durum || 'Yeni',
                });
                setGeriAramaTarihi(interviewToEdit.geriAramaTarihi ? interviewToEdit.geriAramaTarihi.toDate() : null);
            } else {
                setFormData({ adSoyad: '', telefon: '', ilgilenilenHizmet: '', cihazHizmet: '', notlar: '', durum: 'Yeni' });
                setGeriAramaTarihi(null);
            }
        }
    }, [isOpen, interviewToEdit, isEditing]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!formData.adSoyad || !formData.telefon) {
            alert('Ad Soyad ve Telefon alanları zorunludur.');
            return;
        }

        setIsSaving(true);
        const dataToSubmit = {
            ...formData,
            geriAramaTarihi: geriAramaTarihi ? Timestamp.fromDate(geriAramaTarihi) : null,
        };

        try {
            if (isEditing) {
                await updateDoc(doc(db, "preInterviews", interviewToEdit.id), dataToSubmit);
                alert('Ön görüşme başarıyla güncellendi!');
            } else {
                await addDoc(collection(db, "preInterviews"), {
                    ...dataToSubmit,
                    olusturmaTarihi: serverTimestamp(),
                    olusturanKullaniciId: currentUser.uid
                });
                alert('Ön görüşme başarıyla oluşturuldu!');
            }

            if (formData.durum === 'Aranacak' && geriAramaTarihi) {
                await addDoc(collection(db, "notifications"), {
                    userId: currentUser.uid,
                    title: "Geri Arama Hatırlatıcı",
                    message: `${formData.adSoyad} adlı kişiyi geri aramanız gerekiyor.`,
                    link: `/on-gorusme`,
                    timestamp: serverTimestamp(),
                    isRead: false
                });
            }
            onClose();
        } catch (error) {
            console.error("Ön görüşme kaydedilirken hata: ", error);
            alert('Bir hata oluştu.');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEditing ? 'Ön Görüşmeyi Düzenle' : 'Yeni Ön Görüşme Oluştur'}</DialogTitle>
            <DialogContent>
                <Box component="form" noValidate sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                    <TextField label="Adı Soyadı" name="adSoyad" value={formData.adSoyad} onChange={handleChange} required fullWidth />
                    <TextField label="Telefon Numarası" name="telefon" value={formData.telefon} onChange={handleChange} required fullWidth />
                    <FormControl fullWidth><InputLabel>İlgilenilen Hizmet</InputLabel>
                        <Select name="ilgilenilenHizmet" value={formData.ilgilenilenHizmet} label="İlgilenilen Hizmet" onChange={handleChange}>
                            {hizmetler.map(h => <MenuItem key={h} value={h}>{h}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <TextField label="İlgilenilen Cihaz / Hizmet Detayı" name="cihazHizmet" value={formData.cihazHizmet} onChange={handleChange} fullWidth />
                    <TextField label="Notlar" name="notlar" value={formData.notlar} onChange={handleChange} multiline rows={4} fullWidth />
                    {isEditing && (
                        <FormControl fullWidth><InputLabel>Durum</InputLabel>
                            <Select name="durum" value={formData.durum} label="Durum" onChange={handleChange}>
                                {durumlar.map(d => <MenuItem key={d} value={d}>{d}</MenuItem>)}
                            </Select>
                        </FormControl>
                    )}
                    {(formData.durum === 'Aranacak' || !isEditing) && (
                        <DateTimePicker label="Geri Arama Tarihi" value={geriAramaTarihi} onChange={setGeriAramaTarihi} ampm={false} />
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: '16px 24px' }}>
                <Button onClick={onClose} disabled={isSaving}>İptal</Button>
                <Button onClick={handleSubmit} variant="contained" disabled={isSaving}>
                    {isSaving ? <CircularProgress size={24} /> : (isEditing ? 'Güncelle' : 'Kaydet')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PreInterviewFormModal;